module.exports = __webpack_public_path__ + "img/error_404bg.20bb8c7.webp";